export default __webpack_public_path__ + "static/5-ac70a6547c7d498252f551d2c71ad4ed.jpeg";